import { WebchatInterface } from './Webchat.js'
import { bot, history } from '../../bot/dist/bot.esm.js'

export const chat = new WebchatInterface({ bot, history })

setTimeout(async () => {
  await chat.send({
    text: 'Let\'s go',
    next: 'fallback'
  })
  // await chat.quick(1)
}, 10)
